import { type ChangeEvent, type FormEvent } from 'react'
import { snapshot } from 'valtio'
import { proxyRequestPasswordReset } from '../../proxyRequestPwReset'
import { addToArray } from '../../../../../shared/utils/arrayUtils'
import { FormFieldNamesEnum } from './formFieldNamesEnum'
import { validators } from './validators'
import { executeRequestPasswordReset } from './apiUtils/executeRequestPasswordReset'

export const handleChange = (fieldName: FormFieldNamesEnum) => (e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
  processChange(e.target.value, fieldName)
}

export const processChange = (val: string, fieldName: FormFieldNamesEnum): void => {
  proxyRequestPasswordReset.formValues[fieldName] = val
  proxyRequestPasswordReset.formDirtied = addToArray(proxyRequestPasswordReset.formDirtied, fieldName)
  const validator = validators[fieldName]
  if (validator) { proxyRequestPasswordReset.formErrors[fieldName] = validator(val) }
}

export const handleBlur = (fieldName: FormFieldNamesEnum) => () => {
  proxyRequestPasswordReset.formBlurred = addToArray(proxyRequestPasswordReset.formBlurred, fieldName)
}

export const handleFormSubmit = async (e: FormEvent<HTMLFormElement>): Promise<void> => {
  e.preventDefault()
  const { formValues } = snapshot(proxyRequestPasswordReset)

  await executeRequestPasswordReset({
    email: formValues[FormFieldNamesEnum.Email]?.trim() ?? '',
    ppMerchantId: formValues[FormFieldNamesEnum.PPMerchantId]?.trim() ?? ''
  })
}
